import React, { useEffect } from 'react';
import { useAuthenticationContext } from '../../core/services/AuthenticationProvider';
import { Loader } from '../../core/components';

const SilentRefreshRoute = () => {
  const authContext = useAuthenticationContext();
  
  useEffect(() => {
    if(authContext && authContext.silentRefreshCallback){
      authContext.silentRefreshCallback();
    }
  },[]);
  
  return (
    <Loader main={true} opacity={1} />
  );
};

export default SilentRefreshRoute;
